<template>
  <div id="app-content">

    <vue-scroll ref="body_scroll" :ops="ops">
      <app-content></app-content>
    </vue-scroll>
    <login-reg v-if="$store.getters.loginModal"/>
    <alert-message
      v-if="$store.getters.newMessage.show"
      :type="$store.getters.newMessage.type"
      :messageTitle="$store.getters.newMessage.messageTitle"
      :message="$store.getters.newMessage.message"
    />
    <forget-password v-if="$store.getters.forgetPassword"/>
    <new-password v-if="$store.getters.newPassword"/>
    <payment v-if="$store.getters.paymentModal"/>
    <templates v-if="$store.getters.isOpenTariffModel"/>
    <confirm-modal v-if="$store.getters.isOpenConfirmModal"/>
    <cv-download v-if="$store.getters.cvDownload.show" :cv="$store.getters.cvDownload.cv"/>
    <open-share-modal v-if="$store.getters.openShareModal.show" :type="$store.getters.openShareModal.type"/>

    <modalBuy v-if="$store.getters.modalBuy"/>
    <modalBuyLoad v-if="$store.getters.modalBuyLoad"/>
    <modalLoader v-if="$store.getters.modalLoader"/>

    <v-tour name="myTour" :steps="steps"></v-tour>
  </div>
</template>
<script>
  require('../bootstrap');
  require('vue-tour/dist/vue-tour.css')
  import appContent from "./AppContent";
  import helper from "../mixins/helper.js";
  import error from "../mixins/error.js";
  import footer from "./layouts/footer";
  import header from "./layouts/header";
  import loginReg from "./modals/login-registarion";
  import alertMessage from "./modals/messages/alert-message";
  import forgetPassword from "./modals/forgetPassword/forget";
  import newPassword from "./modals/forgetPassword/newPassord";
  import Payment from "./modals/Payment";
  import CvDownload from "./modals/cv-download";
  import openShareModal from "./modals/open-share-modal";
  import Cookies from "js-cookie";
  import templates from "./modals/Templates";
  import confirmModal from "./modals/ConfirmModal";

  import modalBuy from "./modals/buyTariff/modalBuy";
  import modalBuyLoad from "./modals/buyTariff/modalBuyLoad";
  import modalLoader from "./modals/loader";


  import config from "../config.js";
  import Seo from "../mixins/seo";
  import "vue-slider-component/theme/antd.css";

  export default {
    components: {
      "vue-footer": footer,
      "vue-header": header,
      "login-reg": loginReg,
      "alert-message": alertMessage,
      "forget-password": forgetPassword,
      "new-password": newPassword,
      "app-content": appContent,
      templates,
      Payment,
      CvDownload,
      openShareModal,
      confirmModal,

      modalBuy,
      modalBuyLoad,

      modalLoader
    },
    mixins: [helper, error, Seo],
    data() {
      return {
        isActive: false,
        toggle: false,
        lang: this.$store.getters.locale,
        ops: {
          vuescroll: {
            wheelScrollDuration: 300,
            wheelDirectionReverse: false,
          },
          scrollPanel: {
            scrollingY: true,
          },
          rail: {},
          bar: {
            showDelay: 500,
            onlyShowBarOnScroll: true,
            keepShow: false,
            background: '#c1c1c1',
            opacity: 1,
            specifyBorderRadius: false,
            minSize: 0,
            size: '5px',
          },
        },
        steps: [
          {
            target: '[data-v-step="1"]',
            header: {
              title: 'Get Started',
            },
            content: 'Try it, you\'ll love it!<br>You can put HTML in the steps and completely customize the DOM to suit your needs.',
            params: {
              placement: 'bottom' // Any valid Popper.js placement. See https://popper.js.org/popper-documentation.html#Popper.placements
            }
          }, {
            target: '[data-v-step="2"]',
            header: {
              title: 'Choose cv tariff',
            },
            content: 'Try it, you\'ll love it!<br>You can put HTML in the steps and completely customize the DOM to suit your needs.',
            params: {
              placement: 'bottom' // Any valid Popper.js placement. See https://popper.js.org/popper-documentation.html#Popper.placements
            }
          }, {
            target: '[data-v-step="3"]',
            header: {
              title: 'Choose cv design',
            },
            content: 'Try it, you\'ll love it!<br>You can put HTML in the steps and completely customize the DOM to suit your needs.',
            params: {
              placement: 'bottom' // Any valid Popper.js placement. See https://popper.js.org/popper-documentation.html#Popper.placements
            }
          }
        ]
      };
    },
    watch: {
      $route(to, from) {
        this.handleResize();
        if (config.seo[to.name]) {
          this.setSeo(
            config.seo[to.name][to.params.lang]["title"] || "",
            config.seo[to.name][to.params.lang]["description"] || ""
          );
        }
        if (to.params.lang != from.params.lang) {
          this.$store.commit("translate", this.checkLocale(to.params.lang));
          this.$store.commit("locale", this.getLocale(this.$route.params.lang));
        } else if (to.path !== from.path) {
          this.$scrollTo("body");
        }
        if (this.$store.getters.cvDownload.show) {
          this.$store.commit("cvDownload");
        }
      }
    },
    created() {
      window.addEventListener('resize', this.handleResize);
      this.handleResize();
    },
    mounted() {
      if (this.$route.params.lang === undefined) {
        this.$route.params.lang = Cookies.get("locale") || "ru";
      }
      this.setSeo(
        config.seo[this.$route.name] ? config.seo[this.$route.name][this.$route.params.lang]["title"] : config.seo['profile'][this.$route.params.lang]["title"],
        config.seo[this.$route.name] ? config.seo[this.$route.name][this.$route.params.lang]["description"] : config.seo['profile'][this.$route.params.lang]["description"]
      );
      this.$store.commit("translate", this.checkLocale(this.$route.params.lang));
      if (this.$route.query.locale) {
        this.$store.commit("locale", this.getLocale(this.$route.query.locale));
      } else {
        this.$store.commit("locale", this.getLocale(this.$route.params.lang));
      }
      /* handleErrors bolor errorner@ uxarkum enq error mixin */
      var vm = this;
      this.$http.interceptors.response.use(
        function (response) {
          return response;
        },
        function (error) {
          if (error.response) {
            NProgress.done();
            vm.handleErrors(error);
            return Promise.reject(error);
          }
        }
      );
      /* end */
    },
    methods: {
      // handleScroll(vertical, horizontal, nativeEvent) {
      //   var children = this.$children[0].$children[0].$children[0].$children[2];
      //   var refs = children.$refs;
      //   var feedback_block = refs['feedback_block'];
      //   var feedback_block_scroll = refs['feedback_block_scroll'];
      //
      //   if (feedback_block !== undefined) {
      //     if (vertical.scrollTop > feedback_block.offsetTop && feedback_block_scroll.getScrollProcess().v === 0 && children.ops.status === 'top') {
      //       this.$refs['body_scroll'].scrollTo(
      //         {
      //           y: feedback_block.offsetTop
      //         },
      //         500,
      //         "easeInQuad"
      //       );
      //       this.ops.scrollPanel.scrollingY = false;
      //       children.ops.scrollPanel.scrollingY = true;
      //
      //       children.ops.status = 'bottom';
      //     }
      //
      //     if(feedback_block_scroll.getScrollProcess().v === 1 && children.ops.status === 'bottom'){
      //       children.ops.scrollPanel.scrollingY = false;
      //       this.ops.scrollPanel.scrollingY = true;
      //     }
      //
      //
      //     if (vertical.scrollTop < feedback_block.offsetTop && feedback_block_scroll.getScrollProcess().v === 1 && children.ops.status === 'bottom') {
      //       this.$refs['body_scroll'].scrollTo(
      //         {
      //           y: feedback_block.offsetTop
      //         },
      //         500,
      //         "easeInQuad"
      //       );
      //       this.ops.scrollPanel.scrollingY = false;
      //       children.ops.scrollPanel.scrollingY = true;
      //     }
      //   }
      // },
      openLoginModal(status) {
        this.loginModal = status;
      },
      getLocale(locale) {
        if (locale !== this.$Cookies.get("locale")) {
          this.$Cookies.set("locale", locale, {expires: 3});
        }
        return this.$Cookies.get("locale");
      },

      getData() {
        return new Promise((reslove, reject) => {
          if (!this.$store.getters.languages.length) {
            this.$http({
              method: "get",
              url: `/api/main-page/`
            }).then(res => {
              this.$store.commit("languages", res.data.site_languages);
              this.$store.commit("user", res.data.user);
              this.$store.commit("tariffs", res.data.tariffs);
              this.$store.commit("tariffsArray", res.data.tariffsArray);
              reslove(true);
            });
          } else {
            reslove(true);
          }
        });
      },
      forgetPassword(token) {
        this.$http({
          method: "post",
          url: `/api/forget-password/${token}`
        }).then(res => {
          if (res.data.invalid) {
            this.$store.commit("newMessage", {
              show: true,
              type: "error",
              messageTitle: this.$store.getters.t("error"),
              message: this.$store.getters.t("invalid token please try now")
            });
            this.$router.push("home");
          } else if (res.data.timeout) {
            this.$store.commit("newMessage", {
              show: true,
              type: this.$store.getters.t("attention"),
              messageTitle: this.$store.getters.t("timeout"),
              message: this.$store.getters.t("token time ended")
            });
            this.$router.push("home");
          } else if (res.data.token) {
            this.$store.state.forgetEmail = res.data.email;
            this.$store.commit("newPassword", true);
          }
        });
      },
      handleResize() {
        if (window.innerWidth < 1025)
          this.ops.scrollPanel.scrollingY = false;
        else {
          this.ops.scrollPanel.scrollingY = true;
        }
      }
    }
  };
</script>
<style lang="scss">
  @import url("../../../public/floalaEditor/froala_editor.pkgd.min.css");
  @import url("../../../public/floalaEditor/froala_style.min.css");
  @import url("../../../public/vue/custom/css/vue-loader.css");
  @import url("../../../public/vue/custom/css/style.css");
  @import url("../../../public/vue/custom/css/print.css");
</style>



// WEBPACK FOOTER //
// resources/js/components/App.vue